import { AgGridVue } from 'ag-grid-vue'
import { loading, toast } from '@/shared/utils/UIHelper'
import PDRRepository from '@/shared/http/repositories/pci/pdr'
import PDRObraAvaliacaoRepository from '@/shared/http/repositories/pci/pdrobraavaliacao'
import gridMixin from '../mixins/gridMixin'
import CompanyMixin from '@/store/module/company/mixin'
import moment from 'moment'
import Tools from '@/components/tools/Tools'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import PdrGrossValueRenderer from '../components/PdrGrossValueRenderer.vue'

export default {
  name: 'pdrbonusapproval',
  mixins: [gridMixin, CompanyMixin, PermissionMixin],
  components: {
    AgGridVue,
    PdrGrossValueRenderer
  },
  data () {
    return {
      roles: Roles,
      showForm: false,
      formCheckList: null,
      grid: null,
      obrasRowData: [],
      totalWorkRows: 0,
      obrasDataGridOptions: {
        defaultColDef: {
          lockVisible: true,
          suppressDragLeaveHidesColumns: true,
          resizable: true,
          sortable: true
        }
      },
      obrasColumnDefs: [
        {
          headerName: 'Obra',
          field: 'referencia',
          menuTabs: ['filterMenuTab'],
          type: 'textColumn'
        },
        {
          headerName: 'ID Site',
          field: 'idSite',
          menuTabs: ['filterMenuTab'],
          type: 'textColumn'
        },
        {
          headerName: 'Contrato',
          field: 'referenciaContrato',
          menuTabs: ['filterMenuTab'],
          type: 'textColumn',
          width: 300,
          minWidth: 250
        },
        {
          headerName: 'Responsável',
          field: 'responsavelavaliacaofinal',
          menuTabs: ['filterMenuTab'],
          type: 'textColumn'
        },
        {
          headerName: 'Data',
          field: 'terminoanalisefinal',
          menuTabs: ['filterMenuTab'],
          type: 'dateColumn'
        }
      ],
      membersGridOptions: {
        defaultColDef: {
          suppressMovable: true,
          lockVisible: true,
          suppressDragLeaveHidesColumns: true,
          resizable: true
        }
      },
      membersColumnDefs: [
        {
          headerName: 'Membro',
          menuTabs: ['filterMenuTab'],
          field: 'nome',
          width: 300,
          minWidth: 250
        },
        {
          headerName: 'Função',
          menuTabs: ['filterMenuTab'],
          field: 'funcao',
          cellClass: param => {
            return param.data.nome ? '' : 'bold'
          },
          width: 100,
          minWidth: 80
        },
        {
          headerName: 'Nota',
          menuTabs: ['filterMenuTab'],
          field: 'nota',
          type: 'numberZeroColumn',
          cellClass: 'text-right',
          cellClassRules: {
            'low-note': (params) => params.value < 5.9
          },
          width: 100,
          minWidth: 80
        },
        {
          headerName: 'Bruto',
          menuTabs: ['filterMenuTab'],
          cellRenderer: 'PdrGrossValueRenderer',
          width: 200,
          minWidth: 200
        },
        {
          headerName: 'Líquido',
          menuTabs: ['filterMenuTab'],
          field: 'valorLiquido',
          type: 'numberZeroColumn',
          cellClass: param => {
            return param.data.nome ? 'text-right' : 'text-right bold'
          },
          width: 100,
          minWidth: 100
        },
        {
          headerName: 'Observações',
          menuTabs: ['filterMenuTab'],
          field: 'observacoes',
          type: 'memoColumn',
          width: 200,
          minWidth: 200
        }
      ],
      workMemberID: null
    }
  },
  computed: {
    realTerm () {
      return (this.formCheckList.prazoObra || 0) - (this.formCheckList.diasParados || 0)
    }
  },
  beforeMount () {
    this.onLoad()
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {
      setTimeout(() => {
        loading.push()
        PDRRepository.GetPDRWorks({params: {statusPDR: 3}})
          .then(response => {
            if (response.data.code > 0) {
              const data = response.data.data[0]
              this.obrasRowData = data ? data.Data : []
              this.totalWorkRows = this.obrasRowData.length
            }
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => loading.close())
      }, 500)
    },
    onFilterChange (params) {
      this.totalWorkRows = params.api.rowModel.rowsToDisplay.length
    },
    viewForm (params) {
      loading.push()
      PDRRepository.GetCheckListBonus(params.node.data.id, {
        params: {
          mostrarMembrosOcultados: false
        }
      })
        .then(response => {
          this.formCheckList = response.data.data

          const mInicio = moment(this.formCheckList.inicioObra).startOf('day')
          const mTermino = moment(this.formCheckList.terminoObra).startOf('day')

          this.formCheckList.inicioObra = mInicio.toDate().toLocaleDateString()
          this.formCheckList.terminoObra = mTermino.toDate().toLocaleDateString()
          this.formCheckList.diasParados = response.data.data.paralisacoes
          this.formCheckList.prazoObra = mTermino.diff(mInicio, 'days') + 1
          this.formCheckList.valor = this.formCheckList.valor ? this.formCheckList.valor.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : null

          const total = {
            funcao: 'TOTAL',
            valorLiquido: this.formCheckList.membros.reduce((acum, obj) => acum + obj.valorLiquido, 0)
          }
          this.formCheckList.membros.push(total)

          this.showForm = true
          this.workMemberID = null
        })
        .finally(() => loading.close())
    },
    approveForm () {
      loading.push()
      PDRObraAvaliacaoRepository.PostApproveTechnicalDirector(this.formCheckList.pdrid)
        .then((response) => {
          if (response.data.code === -400) {
            toast.error(response.data.message)
          } else {
            const lista = this.grid.getSelectedRows()
            this.obrasRowData = this.obrasRowData.filter(row => {
              return lista.indexOf(row) === -1
            })
            this.showForm = false
            this.onLoad()
            toast.success('Aprovado com sucesso')
          }
        })
        .catch(() => {
          // Set a error toast
          toast.error(this.$lang.Common.CouldNotSave)
        })
        .finally(() => loading.close())
    },
    disapproveForm () {
      let obsReject = ''
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.$lang.Common.LabelConfirmation
        ]),
        h('br')
      ])
      messageVNode.children.push(
        h('h6', [
          h('strong', [
            this.$lang.Common.LabelRejectReason
          ])
        ]),
        h('b-textarea', {
          props: { value: obsReject },
          on: { input: (value) => {
            obsReject = value
          } }
        })
      )

      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: this.$lang.Common.ConfirmReject,
        centered: true,
        okTitle: this.$lang.Common.Yes,
        cancelTitle: this.$lang.Common.No,
        headerClass: 'justify-content-center'
      })
        .then((value) => {
          if (value) {
            loading.push()
            PDRObraAvaliacaoRepository.PostRepproveTechnicalDirector(this.formCheckList.pdrid, { motivo: obsReject })
              .then((response) => {
                if (response.data.code > 0) {
                  const lista = this.grid.getSelectedRows()
                  this.obrasRowData = this.obrasRowData.filter(row => {
                    return lista.indexOf(row) === -1
                  })
                  this.showForm = false
                  this.onLoad()
                  toast.success('Reprovado com sucesso')
                } else {
                  toast.error(response.data.message)
                }
              })
              .catch(() => {
                // Set a error toast
                toast.error(this.$lang.Commom.CouldNotSave)
              })
              .finally(() => loading.close())
          }
        })
    },
    disapproveEngManagerForm () {
      let obsReject = ''
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.$lang.Common.LabelConfirmation
        ]),
        h('br')
      ])
      messageVNode.children.push(
        h('h6', [
          h('strong', [
            this.$lang.Common.LabelRejectReason
          ])
        ]),
        h('b-textarea', {
          props: { value: obsReject },
          on: { input: (value) => {
            obsReject = value
          } }
        })
      )

      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: this.$lang.Common.ConfirmReject,
        centered: true,
        okTitle: this.$lang.Common.Yes,
        cancelTitle: this.$lang.Common.No,
        headerClass: 'justify-content-center'
      })
        .then((value) => {
          if (value) {
            loading.push()
            PDRObraAvaliacaoRepository.PostRepproveEngineeringManager(this.formCheckList.pdrid, { motivo: obsReject })
              .then((response) => {
                if (response.data.code > 0) {
                  const lista = this.grid.getSelectedRows()
                  this.obrasRowData = this.obrasRowData.filter(row => {
                    return lista.indexOf(row) === -1
                  })
                  this.showForm = false
                  this.onLoad()
                  toast.success('Reprovado com sucesso')
                } else {
                  toast.error(response.data.message)
                }
              })
              .catch(() => {
                // Set a error toast
                toast.error(this.$lang.Commom.CouldNotSave)
              })
              .finally(() => loading.close())
          }
        })
    },
    onGridReady (params) {
      this.grid = params.api
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    },
    onHide () {
      this.$refs['modal'].hide()
    },
    setWorkMember (params) {
      this.workMemberID = params.api.getModel().getRow(params.rowIndex).data.obraMembroID
    },
    async generatePDF () {
      if (!this.workMemberID) {
        return
      }
      loading.push()
      PDRRepository.GetPDRWorkAppraisalPDF(this.workMemberID)
        .then(response => {
          if (response.data.code > 0) {
            const binary = window.atob(response.data.data.replace(/\s/g, ''))
            const len = binary.length
            const buffer = new ArrayBuffer(len)
            const view = new Uint8Array(buffer)
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i)
            }
            const blob = new Blob([view], {type: 'application/pdf'})

            const fileURL = URL.createObjectURL(blob)
            window.open(fileURL)
          }
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/pdrbonusapproval/pdrbonusapproval.js